module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('link', {
    attrs: {
      "href": "styles/default.css",
      "rel": "stylesheet",
      "type": "text/css"
    }
  }), _vm._v(" "), _c('title', [_vm._v("The Angel\nAnswer Book")]), _vm._v(" "), _c('p', {
    staticClass: "ser1",
    attrs: {
      "id": "aa_5"
    }
  }, [_c('img', {
    attrs: {
      "alt": "images/img-5-1.jpg",
      "src": "images/img-5-1.jpg"
    }
  })]), _vm._v(" "), _c('p', {
    staticClass: "ct",
    attrs: {
      "id": "pABV"
    }
  }, [_c('a', {
    attrs: {
      "href": "#/contents#bb_5"
    }
  }, [_c('span', {
    staticStyle: {
      "color": "#007467"
    }
  }, [_vm._v("What is the best true source for learning about angels?")])])]), _vm._v(" "), _c('p', {
    staticClass: "tx1",
    attrs: {
      "id": "pA7F"
    }
  }, [_c('span', {
    staticClass: "dcap",
    staticStyle: {
      "color": "#007467"
    }
  }, [_vm._v("W")]), _vm._v("e’re curious about angels because angels are curious creatures. Thousands of books,\nstories,\nand speculative accounts have been written to describe their alleged existence and\nactivities. But there is one—and only one—authoritative source of information we\ncan fully trust: the Bible. Even the book you’re reading right now is accurate only\nto the degree it presents the biblical facts. ")]), _vm._v(" "), _c('p', {
    staticClass: "tx",
    attrs: {
      "id": "pAml"
    }
  }, [_vm._v("\nThe Word of God is our primary source of information—the only authoritative and infallible\none—on the intriguing subject of angels. It’s easy to take flying leaps of fancy\non this theme, but what does the Bible say? ")]), _vm._v(" "), _c('p', {
    staticClass: "tx",
    attrs: {
      "id": "pAqrH"
    }
  }, [_vm._v("\nThat was my standard when I worked my way through every book of the Bible, tracking\ndown each reference to angels until I came to the grand crescendo of angelic activity\npermeating the book "), _c('span', {
    attrs: {
      "id": "AEv"
    }
  }, [_vm._v("of Revelation. I found 234 specific passages about good angels\nand another 278 times when God is referred to as the “Lord of hosts” (“hosts” being\nthe angelic armies of heaven). Angels are referenced in thirty-nine books of the\nBible—nineteen in the Old Testament and twenty in the New—and the range of angelic\nactivity spans the Scriptures from Genesis 3:24 to Revelation 22:16. As John Hunter\nput it, “We can as easily think of summer without flowers as of the Bible without\nangels.”"), _c('sup', [_c('span', {
    attrs: {
      "href": "#/chapter112a#mm_ch5_4",
      "id": "nn_ch5_4",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("4")])])])]), _vm._v(" "), _c('p', {
    staticClass: "ser2",
    attrs: {
      "id": "pAXg0"
    }
  }, [_c('img', {
    attrs: {
      "alt": "images/img-23-1.jpg",
      "src": "images/img-23-1.jpg"
    }
  })])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-ba3a34e0","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/chapter05.vue
// module id = 81
// module chunks = 0